import React from "react";

import { UseQueryResult, useQueries } from "@tanstack/react-query";
import { chunk } from "lodash";

import { getCarbonProgramOutcomesAdmin } from "services";

import { combineQueries } from "utils";

import { GET_CARBON_PROGRAM_OUTCOMES_ADMIN, PROGRAM_OUTCOME_CHUNK_SIZE } from "consts";

import { CarbonProgramOutcomesResponse } from "models";

type UseGetCarbonProgramOutcomesReturnType = Pick<UseQueryResult<CarbonProgramOutcomesResponse>, "data" | "isFetching" | "isLoading"> & {
  progress: number;
};

export const useGetAllCarbonProgramOutcomesAdmin = (fieldIds: string[]): UseGetCarbonProgramOutcomesReturnType => {
  const chunks = chunk(fieldIds, PROGRAM_OUTCOME_CHUNK_SIZE);

  const queriesRef = React.useRef<UseQueryResult[]>([]);

  const queries = chunks.map((chunk, page) => {
    // this logic will result in series requests instead of parallel
    const previousQueryStatus = queriesRef.current[page - 1]?.isFetched ?? false;

    return {
      queryKey: [GET_CARBON_PROGRAM_OUTCOMES_ADMIN, chunk],
      queryFn: () => getCarbonProgramOutcomesAdmin({ fieldIds: chunk }),
      staleTime: 1000 * 60 * 60 * 24, // 1 day
      enabled: previousQueryStatus || page === 0, // only fetch if previous query is done
    };
  });

  return useQueries({
    queries,
    combine: combineQueries(true, chunks.length),
  });
};
